import { defineAsyncComponent } from "vue";

const ValidationErrorDetailsTippyButton = defineAsyncComponent(
  () => import("./ValidationErrorDetailsTippyButton.vue"),
);

export { ValidationErrorDetailsTippyButton };
